import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

// Exchange rate: 1 EUR ≈ 4.97 RON (approximate)
const EUR_TO_RON = 4.97;

const translations = {
  ro: {
    // Navbar
    nav_how_it_works: 'Cum funcționează?',
    nav_benefits: 'Beneficii',
    nav_whats_inside: 'Ce conține?',
    nav_faq: 'Întrebări',
    nav_login: 'Autentificare',
    nav_subscribe: 'Abonează-te',
    nav_my_profile: 'Profilul meu',
    nav_admin: 'Panou Admin',
    nav_logout: 'Deconectare',

    // March Promo
    promo_banner: '🇷🇴 OFERTĂ VARĂ: Abonează-te acum și primești LIVRARE GRATUITĂ PE VIAȚĂ! *',
    promo_disclaimer: '* Ofertă valabilă doar în România, până la sfârșitul lunii august.',
    promo_badge: 'Livrare gratuită pe viață',

    // Hero
    hero_badge: 'Pentru prietenii tăi blănoși',
    hero_title_1: 'Cutia lunară',
    hero_title_2: 'cu surprize pentru',
    hero_title_3: 'câinele tău sau pisica ta!',
    hero_subtitle: 'Cutii pline de jucării, gustări și accesorii premium alese special pentru prietenul tău blănos. Personalizate cu drag, livrate cu zâmbet!',
    hero_cta: 'Abonează-te acum',
    hero_price: '119 lei/lună',
    hero_price_eur: '24€/lună',

    // Trust badges
    trust_secure: 'Comandă securizată',
    trust_shipping: 'Livrare în 2 zile',
    trust_warehouse: 'Depozit în România și Bulgaria',

    // How it works
    how_badge: 'Cum funcționează?',
    how_title: 'Trei pași simpli',
    how_subtitle: 'Începe aventura pentru prietenul tău blănos cu doar câteva clicuri.',
    how_step1_title: 'Completezi chestionarul',
    how_step1_desc: 'Răspunzi la câteva întrebări despre animalul tău pentru a personaliza cutia.',
    how_step2_title: 'Primești cutia acasă',
    how_step2_desc: 'În fiecare lună livrăm o cutie plină de surprize direct la ușa ta.',
    how_step3_title: 'Prietenul tău se bucură',
    how_step3_desc: 'Jucării, recompense și accesorii premium pentru momente de neuitat!',

    // Pricing
    pricing_badge: 'Un singur plan simplu',
    pricing_title: 'Abonament lunar',
    pricing_subtitle: 'Fără angajamente pe termen lung. Anulezi oricând.',
    pricing_monthly: 'Lunar',
    pricing_per_month: '/lună',
    pricing_benefit_1: 'Produse premium selectate',
    pricing_benefit_2: '5-7 jucării și recompense',
    pricing_benefit_3: 'Personalizat pentru animalul tău',
    pricing_benefit_4: 'Livrare în 2 zile lucrătoare',
    pricing_subscribe: 'Abonează-te acum',
    pricing_cancel: 'Anulezi oricând, fără penalități',

    // What's Inside - Box
    box_badge: 'Ce conține cutia?',
    box_title: 'Descoperă surprizele',
    box_subtitle: 'Fiecare cutie este personalizată pentru animalul tău!',
    box_item_1: 'Jucării interactive',
    box_item_1_desc: 'Selectate pentru ore de distracție',
    box_item_2: 'Recompense delicioase',
    box_item_2_desc: 'Gustări naturale și sănătoase',
    box_item_3: 'Accesorii utile',
    box_item_3_desc: 'De la zgărzi la perii',
    box_item_4: 'Produse de îngrijire',
    box_item_4_desc: 'Pentru un blăniș fericit',
    box_item_5: 'Surprize lunare',
    box_item_5_desc: 'Teme diferite în fiecare lună',
    box_item_6: 'Calitate premium',
    box_item_6_desc: 'Doar cele mai bune branduri',

    // Benefits / For Pet Parents
    benefits_badge: 'De ce PetsBox?',
    benefits_title: 'Beneficii pentru tine și animalul tău',
    benefits_subtitle: 'Tot ce ai nevoie într-o singură cutie, livrată lunar.',
    benefit_1: 'Produse premium',
    benefit_1_desc: 'Doar cele mai bune branduri și materiale.',
    benefit_2: 'Personalizare completă',
    benefit_2_desc: 'Cutia adaptată la mărimea și preferințele animalului.',
    benefit_3: 'Recompense naturale',
    benefit_3_desc: 'Ingrediente sănătoase, fără aditivi.',
    benefit_4: 'Jucării durabile',
    benefit_4_desc: 'Făcute să reziste la joacă intensă.',
    benefit_5: 'Livrare rapidă',
    benefit_5_desc: 'În 2 zile lucrătoare, cu DPD Romania.',
    benefit_6: 'Flexibilitate totală',
    benefit_6_desc: 'Anulează oricând, fără penalități.',

    // FAQ
    faq_badge: 'Întrebări frecvente',
    faq_title: 'Ai întrebări?',
    faq_subtitle: 'Avem răspunsuri! Iată cele mai frecvente întrebări.',
    faq_q1: 'Cum funcționează abonamentul?',
    faq_a1: 'După ce completezi chestionarul și te abonezi, vei primi în fiecare lună o cutie personalizată. Fiecare cutie conține 5-7 produse premium pentru animalul tău.',
    faq_q2: 'Pot anula oricând?',
    faq_a2: 'Da, poți anula abonamentul oricând din profilul tău. Nu există perioade minime sau penalități.',
    faq_q3: 'Cât durează livrarea?',
    faq_a3: 'Cutiile sunt livrate în 2 zile lucrătoare cu DPD Romania. Avem depozite în România și Bulgaria.',
    faq_q4: 'Ce conține cutia?',
    faq_a4: 'Fiecare cutie conține 5-7 produse: jucării, recompense naturale și accesorii premium, personalizate pentru tipul și mărimea animalului tău.',
    faq_q5: 'Produsele sunt sigure?',
    faq_a5: 'Absolut! Toate produsele sunt atent selectate și testate pentru siguranță. Folosim doar produse de calitate premium.',
    faq_q6: 'Ce fac dacă animalul meu are alergii?',
    faq_a6: 'În chestionar îți cerem să specifici alergiile animalului tău și vom evita acele ingrediente în cutiile tale.',
    faq_q7: 'Pot face upgrade la cutie?',
    faq_a7: 'Da! Poți alege opțiunea de upgrade pentru doar 10 lei (2€) în plus pe lună și primești o cutie mai mare cu mai multe produse.',

    // Funnel
    funnel_step: 'Pas',
    funnel_of: 'din',
    funnel_next: 'Continuă',
    funnel_back: 'Înapoi',
    funnel_finish: 'Finalizează comanda',
    funnel_pay: 'Plateste acum',
    
    // Step 1: Pet Type
    funnel_s1_title: 'Ce fel de animal ai?',
    funnel_s1_subtitle: 'Selectează tipul de animal pentru a personaliza cutia.',
    funnel_dog: 'Câine',
    funnel_cat: 'Pisică',
    
    // Step 2: Dog Size (dogs only)
    funnel_s2_title: 'Cât de mare este câinele tău?',
    funnel_s2_subtitle: 'Alegem jucării și recompense potrivite pentru mărimea lui.',
    funnel_size_small: 'Mic (1-8 kg)',
    funnel_size_medium: 'Mediu (8-20 kg)',
    funnel_size_large: 'Mare (peste 20 kg)',
    funnel_destroys: 'Câinele tău distruge jucăriile?',
    funnel_destroys_yes: 'Da, le distruge repede',
    funnel_destroys_no: 'Nu, sunt rezistente',
    
    // Step 3: Pet Name & Gender
    funnel_s3_title: 'Cum se numește prietenul tău?',
    funnel_s3_subtitle: 'Vrem să-l cunoaștem mai bine!',
    funnel_pet_name: 'Numele animalului',
    funnel_gender: 'Este băiat sau fată?',
    funnel_boy: 'Băiat',
    funnel_girl: 'Fată',
    
    // Step 4: Breed & Age
    funnel_s4_title: 'Detalii despre rasă și vârstă',
    funnel_s4_subtitle: 'Acestea ne ajută să personalizăm și mai bine cutia.',
    funnel_breed: 'Rasa (opțional)',
    funnel_breed_placeholder: 'Ex: Labrador, Siamez...',
    funnel_age: 'Vârsta',
    funnel_age_placeholder: 'Ex: 2 ani',
    funnel_dont_know: 'Nu știu exact',
    
    // Step 5: Allergies
    funnel_s5_title: 'Are animalul tău alergii?',
    funnel_s5_subtitle: 'Vom evita aceste ingrediente în cutiile tale.',
    funnel_allergy_chicken: 'Pui',
    funnel_allergy_beef: 'Vită',
    funnel_allergy_other: 'Altele',
    funnel_allergy_none: 'Fără alergii',
    funnel_allergy_other_placeholder: 'Specifică alergia...',
    
    // Step 6: Upgrade
    funnel_s6_title: 'Vrei o cutie mai mare?',
    funnel_s6_subtitle: 'Pentru doar 10 lei (2€) în plus pe lună, primești mai multe produse!',
    funnel_upgrade_yes: 'Da, vreau upgrade!',
    funnel_upgrade_no: 'Nu, mulțumesc',
    funnel_upgrade_benefits: 'Cu upgrade primești: 2-3 produse extra, jucării premium, recompense în plus',
    funnel_upgrade_price: '+10 lei/lună',
    
    // Step 7: Contact Info
    funnel_s7_title: 'Unde livrăm cutia?',
    funnel_s7_subtitle: 'Completează datele pentru livrare.',
    funnel_name: 'Nume complet',
    funnel_phone: 'Telefon',
    funnel_email: 'Email',
    funnel_address: 'Adresa completă',
    funnel_address_placeholder: 'Strada, număr, bloc, scară, apartament, oraș, cod poștal',

    // Order Summary
    funnel_summary: 'Rezumat comandă',
    funnel_monthly_sub: 'Abonament lunar PetsBox',
    funnel_upgrade_label: 'Upgrade cutie mare',
    funnel_total: 'Total lunar',
    funnel_free_delivery: 'Livrare GRATUITĂ pe viață (ofertă vară)',

    // Footer
    footer_tagline: 'Cutii lunare pentru câini și pisici fericiți. Jucării, recompense și accesorii premium.',
    footer_quick_links: 'Linkuri rapide',
    footer_legal: 'Legal',
    footer_terms: 'Termeni și condiții',
    footer_privacy: 'Politica de confidențialitate',
    footer_shipping: 'Politica de livrare',
    footer_returns: 'Politica de returnare',
    footer_contact: 'Contact',
    footer_rights: 'Toate drepturile rezervate.',
    footer_country: 'Livrare în România și Bulgaria',

    // Auth Modal
    auth_login_title: 'Bine ai revenit',
    auth_login_subtitle: 'Intră în contul tău',
    auth_register_title: 'Creează un cont',
    auth_register_subtitle: 'Alătură-te familiei PetsBox',
    auth_google: 'Continuă cu Google',
    auth_or: 'sau cu email',
    auth_name: 'Nume',
    auth_email: 'Email',
    auth_password: 'Parolă',
    auth_login_btn: 'Autentificare',
    auth_login_success: 'Autentificare reușită!',
    auth_register_success: 'Cont creat cu succes!',
    auth_register_btn: 'Înregistrare',
    auth_no_account: 'Nu ai cont?',
    auth_have_account: 'Ai deja cont?',
    auth_register_link: 'Înregistrează-te',
    auth_login_link: 'Autentifică-te',

    // Checkout
    checkout_checking: 'Verificăm plata...',
    checkout_checking_desc: 'Te rugăm să aștepți câteva secunde.',
    checkout_success: 'Mulțumim pentru comandă!',
    checkout_success_desc: 'Abonamentul tău a fost activat cu succes. Prima cutie va fi livrată în 2 zile lucrătoare. Verifică email-ul pentru detaliile contului tău.',
    checkout_to_profile: 'Mergi la profil',
    checkout_to_home: 'Acasă',
    checkout_failed: 'Plata nu a reușit',
    checkout_failed_desc: 'Din păcate, plata nu a fost procesată. Te rugăm să încerci din nou.',
    checkout_retry: 'Încearcă din nou',
    checkout_contact: 'Contactează-ne',

    // Legal
    legal_title: 'Informații legale',
    legal_subtitle: 'Protecția consumatorilor',
    legal_company_title: 'Compania',
    legal_company_status: 'Status',
    legal_company_status_text: 'Companie înregistrată în Bulgaria',
    legal_company_note: 'КНС ТРЕЙДИНГ ЕВРОПА ЕООД (KNS TRADING EUROPE), CUI: BG207617173. Sediu: Bulgaria, Sofia district, Opitsvet, str. 23. Email: hello@petsbox.eu | Tel: +359 878 433 982.',
    legal_payment_title: 'Plăți securizate',
    legal_payment_text: 'Toate plățile sunt procesate securizat prin Stripe. Nu stocăm datele cardului tău. Acceptăm Visa, Mastercard, Apple Pay și Google Pay.',
    legal_delivery_title: 'Livrare',
    legal_delivery_text: 'Livrăm prin DPD Romania în România și Bulgaria. Timpul de livrare este de 2 zile lucrătoare. Livrare GRATUITĂ pe viață pentru abonații din iulie și august!',
    legal_cancel_title: 'Anulare abonament',
    legal_cancel_text: 'Poți anula abonamentul oricând, fără penalități. Anularea va fi efectivă la sfârșitul perioadei de facturare curente. Contactează-ne la hello@petsbox.eu sau +359 878 433 982.',
    legal_privacy_title: 'Confidențialitate',
    legal_privacy_text: 'Respectăm GDPR și protejăm datele tale personale. Colectăm doar informațiile necesare pentru procesarea comenzilor și livrare. Nu vindem datele tale terților. Ai dreptul să soliciți ștergerea datelor tale contactându-ne la hello@petsbox.eu.',
    legal_contact_title: 'Contact',
    legal_contact_text: 'КНС ТРЕЙДИНГ ЕВРОПА ЕООД (KNS TRADING EUROPE) | CUI: BG207617173 | Bulgaria, Sofia district, Opitsvet, str. 23 | Email: hello@petsbox.eu | Tel: +359 878 433 982 (Viber & WhatsApp disponibil)',

    // Dashboard / Profile
    dash_hello: 'Salut',
    dash_subtitle: 'Gestionează abonamentul și profilul animalului tău',
    dash_profile_tab: 'Profil',
    dash_subscription_tab: 'Abonament',
    dash_badge_tab: 'Nivel',
    dash_support_tab: 'Suport',
    dash_boxes_tab: 'Cutiile mele',
    dash_active_subs: 'Abonamente active',
    dash_saved: 'Salvat cu succes!',
    dash_profile_why: 'Completează profilul pentru a personaliza cutiile pentru animalul tău. Cu cât știm mai multe, cu atât cutia va fi mai potrivită!',
    dash_profile_title: 'Detalii animal',
    dash_pet_name: 'Numele animalului',
    dash_pet_type: 'Tip animal',
    dash_pet_age: 'Vârsta',
    dash_pet_size: 'Mărime',
    dash_address: 'Adresa de livrare',
    dash_city: 'Oraș',
    dash_phone: 'Telefon',
    dash_contact_email: 'Email de contact',
    dash_save: 'Salvează',
    dash_no_sub: 'Niciun abonament activ',
    dash_no_sub_desc: 'Abonează-te acum pentru a primi lunar o cutie cu surprize!',
    dash_see_plans: 'Vezi oferta',
    dash_cancel_confirm: 'Ești sigur că vrei să anulezi abonamentul?',
    dash_cancelled: 'Abonament anulat',
    dash_cancel_sub: 'Anulează abonamentul',
    dash_skip_month: 'Sari luna următoare',
    dash_skip_confirm: 'Ești sigur că vrei să sari luna următoare?',
    dash_skipped: 'Luna a fost sărită cu succes!',
    dash_skipped_months: 'Luni sărite',
    dash_next_billing: 'Următoarea facturare',
    dash_dog_size: 'Mărimea câinelui',
    dash_box_for_month: 'Cutia pentru',
    dash_box_preparing: 'Se pregătește',
    dash_box_shipped: 'Expediată',
    dash_box_delivered: 'Livrată',
    dash_box_tracking: 'Tracking',
    dash_new_ticket: 'Trimite un mesaj',
    dash_ticket_subject: 'Subiect',
    dash_ticket_message: 'Mesaj',
    dash_ticket_send: 'Trimite',
    dash_ticket_sent: 'Mesaj trimis cu succes!',
    dash_total_orders: 'Total cutii',
    dash_member_since: 'Membru din',
    pet_dogs: 'Câine',
    pet_cats: 'Pisică',
    pricing_dog_box: 'Cutia pentru câini',
    pricing_cat_box: 'Cutia pentru pisici',
    pricing_1_month: 'Preț lunar',
    status_active: 'Activ',
    status_cancelled: 'Anulat',
    status_pending: 'În așteptare',

    // Social Proof & Trust Guarantees
    social_proof_boxes: 'Peste 5100 de cutii trimise',
    social_proof_counting: 'și numărul crește!',
    social_proof_pets: 'animăluțe fericite',
    trust_guarantee_title: 'De ce ne aleg proprietarii de animale',
    trust_g1_title: '5100+ cutii livrate',
    trust_g1_desc: 'O comunitate în creștere de proprietari de animale fericiți din România și Bulgaria care au încredere în PetsBox în fiecare lună.',
    trust_g2_title: 'Valoare peste 200 lei garantată',
    trust_g2_desc: 'Fiecare cutie conține produse premium în valoare de peste 200 lei. Dacă nu ești mulțumit, îți returnăm banii — garantat.',
    trust_g3_title: 'Anulezi oricând din cont',
    trust_g3_desc: 'Fără angajamente. Fără penalități. Intri în contul tău și anulezi cu un singur click, oricând dorești.',
    trust_money_back: 'Garanție de returnare a banilor',
    trust_no_lock: 'Fără contract',

    // Common
    loading: 'Se încarcă...',
    error: 'Eroare',
    success: 'Succes',
    cancel: 'Anulează',
    save: 'Salvează',
    currency: 'lei',
    currency_symbol: 'lei',
  },
  en: {
    // Navbar
    nav_how_it_works: 'How it works',
    nav_benefits: 'Benefits',
    nav_whats_inside: "What's inside",
    nav_faq: 'FAQ',
    nav_login: 'Login',
    nav_subscribe: 'Subscribe',
    nav_my_profile: 'My Profile',
    nav_admin: 'Admin Panel',
    nav_logout: 'Logout',

    // March Promo
    promo_banner: '🇷🇴 SUMMER OFFER: Subscribe now and get FREE DELIVERY FOR LIFE! *',
    promo_disclaimer: '* Offer limited to Romania, valid until the end of August.',
    promo_badge: 'Free delivery for life',

    // Hero
    hero_badge: 'For your furry friends',
    hero_title_1: 'The monthly box',
    hero_title_2: 'of surprises for',
    hero_title_3: 'your dog or cat!',
    hero_subtitle: 'Monthly boxes packed with toys, treats & premium goodies handpicked for your furry companion. Personalized with love, delivered with a smile!',
    hero_cta: 'Subscribe now',
    hero_price: '€24/month',
    hero_price_eur: '€24/month',

    // Trust badges
    trust_secure: 'Secure order',
    trust_shipping: '2-day delivery',
    trust_warehouse: 'Warehouse in Romania & Bulgaria',

    // How it works
    how_badge: 'How it works',
    how_title: 'Three simple steps',
    how_subtitle: 'Start the adventure for your furry friend with just a few clicks.',
    how_step1_title: 'Complete the questionnaire',
    how_step1_desc: 'Answer a few questions about your pet to personalize the box.',
    how_step2_title: 'Receive box at home',
    how_step2_desc: 'Every month we deliver a box full of surprises right to your door.',
    how_step3_title: 'Your friend enjoys',
    how_step3_desc: 'Premium toys, treats, and accessories for unforgettable moments!',

    // Pricing
    pricing_badge: 'One simple plan',
    pricing_title: 'Monthly subscription',
    pricing_subtitle: 'No long-term commitment. Cancel anytime.',
    pricing_monthly: 'Monthly',
    pricing_per_month: '/month',
    pricing_benefit_1: 'Premium curated products',
    pricing_benefit_2: '5-7 toys and treats',
    pricing_benefit_3: 'Personalized for your pet',
    pricing_benefit_4: '2-day delivery',
    pricing_subscribe: 'Subscribe now',
    pricing_cancel: 'Cancel anytime, no penalties',

    // What's Inside - Box
    box_badge: "What's in the box?",
    box_title: 'Discover the surprises',
    box_subtitle: 'Every box is personalized for your pet!',
    box_item_1: 'Interactive toys',
    box_item_1_desc: 'Selected for hours of fun',
    box_item_2: 'Delicious treats',
    box_item_2_desc: 'Natural and healthy snacks',
    box_item_3: 'Useful accessories',
    box_item_3_desc: 'From collars to brushes',
    box_item_4: 'Grooming products',
    box_item_4_desc: 'For a happy fur baby',
    box_item_5: 'Monthly surprises',
    box_item_5_desc: 'Different themes each month',
    box_item_6: 'Premium quality',
    box_item_6_desc: 'Only the best brands',

    // Benefits / For Pet Parents
    benefits_badge: 'Why PetsBox?',
    benefits_title: 'Benefits for you and your pet',
    benefits_subtitle: 'Everything you need in one box, delivered monthly.',
    benefit_1: 'Premium products',
    benefit_1_desc: 'Only the best brands and materials.',
    benefit_2: 'Full personalization',
    benefit_2_desc: 'Box adapted to your pet\'s size and preferences.',
    benefit_3: 'Natural treats',
    benefit_3_desc: 'Healthy ingredients, no additives.',
    benefit_4: 'Durable toys',
    benefit_4_desc: 'Made to withstand intense play.',
    benefit_5: 'Fast delivery',
    benefit_5_desc: '2 business days with DPD Romania.',
    benefit_6: 'Total flexibility',
    benefit_6_desc: 'Cancel anytime, no penalties.',

    // FAQ
    faq_badge: 'FAQ',
    faq_title: 'Got questions?',
    faq_subtitle: 'We have answers! Here are the most common questions.',
    faq_q1: 'How does the subscription work?',
    faq_a1: 'After you complete the questionnaire and subscribe, you will receive a personalized box every month. Each box contains 5-7 premium products for your pet.',
    faq_q2: 'Can I cancel anytime?',
    faq_a2: 'Yes, you can cancel your subscription at any time from your profile. There are no minimum periods or penalties.',
    faq_q3: 'How long does delivery take?',
    faq_a3: 'Boxes are delivered within 2 business days via DPD Romania. We have warehouses in Romania and Bulgaria.',
    faq_q4: 'What\'s in the box?',
    faq_a4: 'Each box contains 5-7 products: toys, natural treats, and premium accessories, personalized for your pet\'s type and size.',
    faq_q5: 'Are the products safe?',
    faq_a5: 'Absolutely! All products are carefully selected and tested for safety. We only use premium quality products.',
    faq_q6: 'What if my pet has allergies?',
    faq_a6: 'In the questionnaire, we ask you to specify your pet\'s allergies and we\'ll avoid those ingredients in your boxes.',
    faq_q7: 'Can I upgrade my box?',
    faq_a7: 'Yes! You can choose the upgrade option for just €2 extra per month and get a bigger box with more products.',

    // Funnel
    funnel_step: 'Step',
    funnel_of: 'of',
    funnel_next: 'Continue',
    funnel_back: 'Back',
    funnel_finish: 'Complete order',
    funnel_pay: 'Pay now',
    
    // Step 1: Pet Type
    funnel_s1_title: 'What kind of pet do you have?',
    funnel_s1_subtitle: 'Select your pet type to personalize the box.',
    funnel_dog: 'Dog',
    funnel_cat: 'Cat',
    
    // Step 2: Dog Size (dogs only)
    funnel_s2_title: 'How big is your dog?',
    funnel_s2_subtitle: 'We\'ll choose toys and treats suitable for their size.',
    funnel_size_small: 'Small (1-8 kg)',
    funnel_size_medium: 'Medium (8-20 kg)',
    funnel_size_large: 'Large (over 20 kg)',
    funnel_destroys: 'Does your dog destroy toys?',
    funnel_destroys_yes: 'Yes, quickly',
    funnel_destroys_no: 'No, they last',
    
    // Step 3: Pet Name & Gender
    funnel_s3_title: 'What\'s your friend\'s name?',
    funnel_s3_subtitle: 'We want to get to know them better!',
    funnel_pet_name: 'Pet name',
    funnel_gender: 'Is it a boy or girl?',
    funnel_boy: 'Boy',
    funnel_girl: 'Girl',
    
    // Step 4: Breed & Age
    funnel_s4_title: 'Breed and age details',
    funnel_s4_subtitle: 'This helps us personalize the box even better.',
    funnel_breed: 'Breed (optional)',
    funnel_breed_placeholder: 'E.g.: Labrador, Siamese...',
    funnel_age: 'Age',
    funnel_age_placeholder: 'E.g.: 2 years',
    funnel_dont_know: 'I don\'t know exactly',
    
    // Step 5: Allergies
    funnel_s5_title: 'Does your pet have allergies?',
    funnel_s5_subtitle: 'We\'ll avoid these ingredients in your boxes.',
    funnel_allergy_chicken: 'Chicken',
    funnel_allergy_beef: 'Beef',
    funnel_allergy_other: 'Other',
    funnel_allergy_none: 'No allergies',
    funnel_allergy_other_placeholder: 'Specify allergy...',
    
    // Step 6: Upgrade
    funnel_s6_title: 'Want a bigger box?',
    funnel_s6_subtitle: 'For just €2 extra per month, you get more products!',
    funnel_upgrade_yes: 'Yes, I want upgrade!',
    funnel_upgrade_no: 'No, thanks',
    funnel_upgrade_benefits: 'With upgrade you get: 2-3 extra products, premium toys, extra treats',
    funnel_upgrade_price: '+€2/month',
    
    // Step 7: Contact Info
    funnel_s7_title: 'Where do we deliver?',
    funnel_s7_subtitle: 'Complete your delivery details.',
    funnel_name: 'Full name',
    funnel_phone: 'Phone',
    funnel_email: 'Email',
    funnel_address: 'Full address',
    funnel_address_placeholder: 'Street, number, building, apartment, city, postal code',

    // Order Summary
    funnel_summary: 'Order summary',
    funnel_monthly_sub: 'PetsBox monthly subscription',
    funnel_upgrade_label: 'Large box upgrade',
    funnel_total: 'Monthly total',
    funnel_free_delivery: 'FREE delivery for life (Summer offer)',

    // Footer
    footer_tagline: 'Monthly boxes for happy dogs and cats. Toys, treats, and premium accessories.',
    footer_quick_links: 'Quick Links',
    footer_legal: 'Legal',
    footer_terms: 'Terms of Service',
    footer_privacy: 'Privacy Policy',
    footer_shipping: 'Shipping Policy',
    footer_returns: 'Return Policy',
    footer_contact: 'Contact',
    footer_rights: 'All rights reserved.',
    footer_country: 'Shipping in Romania & Bulgaria',

    // Auth Modal
    auth_login_title: 'Welcome back',
    auth_login_subtitle: 'Sign in to your account',
    auth_register_title: 'Create an account',
    auth_register_subtitle: 'Join the PetsBox family',
    auth_google: 'Continue with Google',
    auth_or: 'or with email',
    auth_name: 'Name',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_login_btn: 'Sign in',
    auth_login_success: 'Logged in successfully!',
    auth_register_success: 'Account created successfully!',
    auth_register_btn: 'Sign up',
    auth_no_account: "Don't have an account?",
    auth_have_account: 'Already have an account?',
    auth_register_link: 'Sign up',
    auth_login_link: 'Sign in',

    // Checkout
    checkout_checking: 'Verifying your payment...',
    checkout_checking_desc: 'Please wait a few seconds.',
    checkout_success: 'Thank you for your order!',
    checkout_success_desc: 'Your subscription has been activated. Your first box will be shipped within 2 business days. Check your email for account details.',
    checkout_to_profile: 'Go to profile',
    checkout_to_home: 'Home',
    checkout_failed: 'Payment failed',
    checkout_failed_desc: 'Unfortunately, the payment could not be processed. Please try again.',
    checkout_retry: 'Try again',
    checkout_contact: 'Contact us',

    // Legal
    legal_title: 'Legal Information',
    legal_subtitle: 'Consumer Protection',
    legal_company_title: 'Company',
    legal_company_status: 'Status',
    legal_company_status_text: 'Registered company in Bulgaria',
    legal_company_note: 'КНС ТРЕЙДИНГ ЕВРОПА ЕООД (KNS TRADING EUROPE), VAT: BG207617173. Address: Bulgaria, Sofia district, Opitsvet, str. 23. Email: hello@petsbox.eu | Phone: +359 878 433 982.',
    legal_payment_title: 'Secure Payments',
    legal_payment_text: 'All payments are securely processed through Stripe. We never store your card details. We accept Visa, Mastercard, Apple Pay and Google Pay.',
    legal_delivery_title: 'Delivery',
    legal_delivery_text: 'We deliver via DPD Romania in Romania and Bulgaria. Delivery time is 2 business days. FREE delivery for life for July & August subscribers!',
    legal_cancel_title: 'Cancellation',
    legal_cancel_text: 'You can cancel your subscription at any time, with no penalties. Cancellation takes effect at the end of the current billing period. Contact us at hello@petsbox.eu or +359 878 433 982.',
    legal_privacy_title: 'Privacy',
    legal_privacy_text: 'We comply with GDPR and protect your personal data. We only collect information necessary for order processing and delivery. We do not sell your data to third parties. You have the right to request deletion of your data by contacting hello@petsbox.eu.',
    legal_contact_title: 'Contact',
    legal_contact_text: 'КНС ТРЕЙДИНГ ЕВРОПА ЕООД (KNS TRADING EUROPE) | VAT: BG207617173 | Bulgaria, Sofia district, Opitsvet, str. 23 | Email: hello@petsbox.eu | Phone: +359 878 433 982 (Viber & WhatsApp available)',

    // Dashboard / Profile
    dash_hello: 'Hello',
    dash_subtitle: 'Manage your subscription and pet profile',
    dash_profile_tab: 'Profile',
    dash_subscription_tab: 'Subscription',
    dash_badge_tab: 'Level',
    dash_support_tab: 'Support',
    dash_boxes_tab: 'My Boxes',
    dash_active_subs: 'Active subscriptions',
    dash_saved: 'Saved successfully!',
    dash_profile_why: 'Complete your profile to personalize the boxes for your pet. The more we know, the better the box will be!',
    dash_profile_title: 'Pet Details',
    dash_pet_name: 'Pet name',
    dash_pet_type: 'Pet type',
    dash_pet_age: 'Age',
    dash_pet_size: 'Size',
    dash_address: 'Delivery address',
    dash_city: 'City',
    dash_phone: 'Phone',
    dash_contact_email: 'Contact email',
    dash_save: 'Save',
    dash_no_sub: 'No active subscription',
    dash_no_sub_desc: 'Subscribe now to receive a monthly box of surprises!',
    dash_see_plans: 'See our offer',
    dash_cancel_confirm: 'Are you sure you want to cancel your subscription?',
    dash_cancelled: 'Subscription cancelled',
    dash_cancel_sub: 'Cancel subscription',
    dash_skip_month: 'Skip next month',
    dash_skip_confirm: 'Are you sure you want to skip next month?',
    dash_skipped: 'Month skipped successfully!',
    dash_skipped_months: 'Skipped months',
    dash_next_billing: 'Next billing',
    dash_dog_size: 'Dog size',
    dash_box_for_month: 'Box for',
    dash_box_preparing: 'Being prepared',
    dash_box_shipped: 'Shipped',
    dash_box_delivered: 'Delivered',
    dash_box_tracking: 'Tracking',
    dash_new_ticket: 'Send a message',
    dash_ticket_subject: 'Subject',
    dash_ticket_message: 'Message',
    dash_ticket_send: 'Send',
    dash_ticket_sent: 'Message sent successfully!',
    dash_total_orders: 'Total boxes',
    dash_member_since: 'Member since',
    pet_dogs: 'Dog',
    pet_cats: 'Cat',
    pricing_dog_box: 'Dog Box',
    pricing_cat_box: 'Cat Box',
    pricing_1_month: 'Monthly price',
    status_active: 'Active',
    status_cancelled: 'Cancelled',
    status_pending: 'Pending',

    // Social Proof & Trust Guarantees
    social_proof_boxes: 'Over 5100 boxes delivered',
    social_proof_counting: 'and counting!',
    social_proof_pets: 'happy pets',
    trust_guarantee_title: 'Why pet owners choose us',
    trust_g1_title: '5100+ boxes delivered',
    trust_g1_desc: 'A growing community of happy pet owners across Romania and Bulgaria who trust PetsBox every month.',
    trust_g2_title: 'Over 200 lei value guaranteed',
    trust_g2_desc: 'Every box contains premium products worth over 200 lei. Not satisfied? We\'ll give your money back — guaranteed.',
    trust_g3_title: 'Cancel anytime from your account',
    trust_g3_desc: 'No commitments. No penalties. Log into your account and cancel with one click, whenever you want.',
    trust_money_back: 'Money-back guarantee',
    trust_no_lock: 'No contract',

    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    currency: 'EUR',
    currency_symbol: '€',
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('petsbox_language');
    return saved || 'ro';
  });

  useEffect(() => {
    localStorage.setItem('petsbox_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ro' ? 'en' : 'ro');
  };

  // Price conversion
  const formatPrice = (eurPrice, showCurrency = true) => {
    if (language === 'ro') {
      const ronPrice = Math.round(eurPrice * EUR_TO_RON);
      return showCurrency ? `${ronPrice} lei` : ronPrice;
    }
    return showCurrency ? `€${eurPrice}` : eurPrice;
  };

  const getBasePrice = () => language === 'ro' ? 99 : 20; // 20 EUR ≈ 99 RON
  const getUpgradePrice = () => language === 'ro' ? 10 : 2; // 2 EUR ≈ 10 RON

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    formatPrice,
    getBasePrice,
    getUpgradePrice,
    isRomanian: language === 'ro',
    isEnglish: language === 'en',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
